var _path, _path2, _path3, _path4, _path5, _path6, _path7, _line, _path8, _path9, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExactly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9138,
    height: 2529,
    viewBox: "0 0 9138 2529",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.5634 642.088H1569.76Z",
    fill: "#FFFEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5634 642.088H1569.76",
    stroke: "#FFFEFB",
    strokeWidth: 181.126,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M347.159 1276.03H1320.71Z",
    fill: "#FFFEFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.159 1276.03H1320.71",
    stroke: "#FFFEFB",
    strokeWidth: 181.126,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5632 1909.97H1569.76Z",
    fill: "#FFFEFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5632 1909.97H1569.76",
    stroke: "#FFFEFB",
    strokeWidth: 181.126,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1914.08 557.186H2136.96L2519.03 1091.81L2901.08 557.186H3123.96L2630.45 1243.04L3186.31 2000.54H2960.78L2519.03 1394.28L2083.89 2000.54H1862.35L2408.92 1243.04L1914.08 557.186ZM4713.34 557.186V2000.54H4530.27V1752.45C4452.44 1847.09 4364.88 1918.29 4267.6 1966.05C4171.2 2013.8 4065.51 2037.68 3950.54 2037.68C3746.23 2037.68 3571.57 1963.83 3426.53 1816.13C3282.37 1667.55 3210.29 1487.13 3210.29 1274.88C3210.29 1067.05 3283.26 889.281 3429.19 741.584C3575.11 593.888 3750.65 520.041 3955.84 520.041C4074.36 520.041 4181.37 545.246 4276.89 595.657C4373.28 646.069 4457.74 721.685 4530.27 822.507V557.186H4713.34ZM3970.44 699.133C3866.97 699.133 3771.44 724.78 3683.89 776.077C3596.34 826.487 3526.47 897.682 3474.29 989.659C3422.98 1081.64 3397.34 1178.92 3397.34 1281.51C3397.34 1383.23 3423.44 1480.51 3475.61 1573.36C3527.79 1666.24 3597.66 1738.75 3685.22 1790.93C3773.66 1842.23 3868.28 1867.88 3969.11 1867.88C4070.81 1867.88 4167.22 1842.23 4258.31 1790.93C4349.4 1739.64 4419.27 1670.21 4467.92 1582.65C4517.44 1495.1 4542.21 1396.48 4542.21 1286.82C4542.21 1119.67 4486.93 979.931 4376.39 867.612C4266.71 755.292 4131.4 699.133 3970.44 699.133ZM6424.77 856.999L6277.52 948.535C6150.16 779.613 5976.38 695.152 5756.16 695.152C5580.17 695.152 5433.79 751.755 5317.05 864.958C5201.19 978.162 5143.26 1115.69 5143.26 1277.53C5143.26 1382.77 5169.79 1481.84 5222.86 1574.69C5276.81 1667.55 5350.21 1739.64 5443.08 1790.93C5536.83 1842.23 5641.63 1867.88 5757.49 1867.88C5969.74 1867.88 6143.09 1783.41 6277.52 1614.5L6424.77 1711.34C6355.78 1814.81 6262.92 1895.29 6146.19 1952.78C6030.33 2009.38 5898.1 2037.68 5749.52 2037.68C5521.35 2037.68 5332.08 1965.16 5181.73 1820.12C5031.38 1675.08 4956.22 1498.63 4956.22 1290.8C4956.22 1151.06 4991.14 1021.5 5061.01 902.104C5131.77 781.824 5228.62 688.078 5351.54 620.864C5474.48 553.648 5612 520.041 5764.12 520.041C5859.63 520.041 5951.61 534.634 6040.05 563.819C6129.37 593.003 6204.99 631.034 6266.91 677.906C6328.81 724.78 6381.44 784.478 6424.77 856.999ZM6836.13 21.2358H7023.17V557.186H7317.68V716.379H7023.17V2000.54H6836.13V716.379H6582.75V557.186H6836.13V21.2358ZM7458.42 0.00927734H7644.13V2000.54H7458.42V0.00927734ZM7766.29 557.186H7962.63L8458.78 1668.88L8940.33 557.186H9138L8277.03 2528.52H8080.69L8359.28 1891.75L7766.29 557.186Z",
    fill: "#FFFEFB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 75.4693,
    y1: 611.9,
    x2: 75.4693,
    y2: 793.027,
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M332.065 1147.14L332.065 1403.74",
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1343.35 1147.14L1343.35 1403.74",
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 75.4693,
    y1: 1759.03,
    x2: 75.4693,
    y2: 1940.16,
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1584.86,
    y1: 1759.03,
    x2: 1584.86,
    y2: 1940.16,
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1584.86,
    y1: 611.9,
    x2: 1584.86,
    y2: 793.027,
    stroke: "#FFFEFB",
    strokeWidth: 150.939
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExactly);
export default __webpack_public_path__ + "static/media/exactly.65d88fd08e39c318f962100262db6918.svg";
export { ForwardRef as ReactComponent };